import classNames, { Value as ClassValue } from "classnames";
import React, { CSSProperties } from "react";

export function ButtonNav(props: {
  children?: React.ReactNode;
  className?: ClassValue;
  style?: CSSProperties;
}) {
  return (
    <nav
      className={classNames("buttons is-centered", props.className)}
      style={{ marginTop: "1em", ...props.style }}
    >
      {props.children}
    </nav>
  );
}
